/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Tab_PairingInputs */

const cs_ebr_tab_pairing = /** @type {(inputs: Ebr_Tab_PairingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Párování`)
};

const en_ebr_tab_pairing = /** @type {(inputs: Ebr_Tab_PairingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pairing`)
};

/**
* | output |
* | --- |
* | "Pairing" |
*
* @param {Ebr_Tab_PairingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_tab_pairing = /** @type {((inputs?: Ebr_Tab_PairingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Tab_PairingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_tab_pairing(inputs)
	return cs_ebr_tab_pairing(inputs)
});